import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useState } from 'react';
import { InputText } from 'primereact/inputtext';

const DateTableMon = ({ lstEventos }) => {
    //console.log('WWW00= ', lstEventos)
    const [filtros, setFiltros] = useState({
            global: { value: null, matchMode: 'contains' },
            proyectoNombre: { value: null, matchMode: 'contains' },
            proyectoSigla: { value: null, matchMode: 'contains' },
            puestoNombre: { value: null, matchMode: 'contains' },
            puestoSigla: { value: null, matchMode: 'contains' }
        });
    

    // Estado para los valores visuales de los filtros
    const [valoresFiltros, setValoresFiltros] = useState({
        proyectoNombre: '',
        proyectoSigla: '',
        puestoNombre: '',
        puestoSigla: '',
        global: ''
    });
    // Función para limpiar todos los filtros
    const limpiarFiltros = () => {
        setValoresFiltros({
            proyectoNombre: '',
            proyectoSigla: '',
            puestoNombre: '',
            puestoSigla: '',
            global: ''
        });

        setFiltros({
            global: { value: null, matchMode: 'contains' },
            proyectoNombre: { value: null, matchMode: 'contains' },
            proyectoSigla: { value: null, matchMode: 'contains' },
            puestoNombre: { value: null, matchMode: 'contains' },
            puestoSigla: { value: null, matchMode: 'contains' }
        });
    };

    const textoFilterTemplate = (options, field) => {
            return (
                <InputText
                    value={valoresFiltros[field]}
                    onChange={(e) => {
                        const nuevoValor = e.target.value;
                        // Actualizamos el valor visual
                        setValoresFiltros((prev) => ({ ...prev, [field]: nuevoValor }));
    
                        // Actualizamos el filtro real después de un pequeño delay
                        setTimeout(() => {
                            const newFilters = { ...filtros };
                            newFilters[field].value = nuevoValor;
                            setFiltros(newFilters);
                            options.filterApplyCallback(nuevoValor);
                        }, 10);
                    }}
                    placeholder={`Filtrar por ${field}`}
                    className="w-full"
                />
            );
        };


    return (
        <div style={{ width: '100%', overflowX: 'auto' }}>
            <DataTable size="small" stripedRows value={lstEventos} paginator rows={5} rowsPerPageOptions={[5, 10, 30, 50, 80, 100, 200]} style={{ minWidth: '300px' }} filters={filtros} filterDisplay="row" emptyMessage="No se encontraron resultados." >
                <Column header="Nombre Proyecto" field="proyectoNombre" style={{ minWidth: '100px' }}
                filter
                filterPlaceholder="Buscar por Proyecto"
                filterElement={(options) => textoFilterTemplate(options, 'proyectoNombre')}
                showFilterMenu={false}
                ></Column>
                <Column header="Sigla Proyecto" field='proyectoSigla' 
                filter
                filterPlaceholder="Buscar por Sigla"
                filterElement={(options) => textoFilterTemplate(options, 'proyectoSigla')}
                showFilterMenu={false}
                ></Column>
                <Column header="Nombre Puesto" field="puestoNombre" style={{ minWidth: '100px' }}
                filter
                filterPlaceholder="Buscar por Puesto"
                filterElement={(options) => textoFilterTemplate(options, 'puestoNombre')}
                showFilterMenu={false}
                ></Column>
                <Column header='Sigla Puesto' field='puestoSigla' 
                filter
                filterPlaceholder="Buscar por Puesto"
                filterElement={(options) => textoFilterTemplate(options, 'puestoSigla')}
                showFilterMenu={false}
                ></Column>
                <Column header="sigla horario" field="horarioSigla" style={{ minWidth: '50px' }}></Column>
                <Column header="horario" field="horaCerca" style={{ minWidth: '50px' }}></Column>
            </DataTable>
        </div>
    );
};

export default DateTableMon;
